import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import { InfoField } from '../../../../../components';
import type { ProfileWithInfo } from '../../../../../types';

type UserInfoProps = {
  profile: ProfileWithInfo | undefined;
};

export const UserInfo: FC<UserInfoProps> = (props) => {
  const { profile } = props;
  const { t } = useTranslation();

  return (
    <Stack direction="column" spacing={1}>
      <InfoField
        name={t('profile-details.user.first-name')}
        value={profile?.user_info?.traits?.first_name}
      />

      <InfoField
        name={t('profile-details.user.last-name')}
        value={profile?.user_info?.traits?.last_name}
      />

      <InfoField
        name={t('profile-details.user.email')}
        value={profile?.user_info?.traits?.email}
        //
      />

      <InfoField
        name={t('profile-details.user.phone')}
        value={profile?.user_info?.traits?.phone}
        withoutDivider
      />
    </Stack>
  );
};
